import { Moment } from 'moment';
import Person from '@/shared/models/Person';
import { DayOfWeek } from '@/shared/models/common';
import { durationAsMinutes } from '@/shared/utils/dateTime';
import PlannerEventType from '../constants/PlannerEventType';
import { PLANNER_END_HOUR, PLANNER_START_HOUR } from '../constants/general';
import Break from './Break';
import BusinessHours from './BusinessHours';
import Competence from './Competence';
import PlannerEvent from './PlannerEvent';
import { PlannerResourceId } from './ids';

/**
 * = mechanic
 */
export default class PlannerResource extends Person<PlannerResourceId> {
  businessHours: Array<BusinessHours> = [];
  competences: Array<Competence> = [];
  breaks: Array<Break> = [];

  getBusinessHoursByDate(date: Moment): BusinessHours | null {
    const dayOfWeek = date.day() as DayOfWeek;
    return this.businessHours.find(item => item.daysOfWeek.includes(dayOfWeek)) ?? null;
  }

  getStartTimeOn(date: Moment): Moment {
    const businessHours = this.getBusinessHoursByDate(date);
    return date.clone().startOf('day').add({
      hours: businessHours?.start.hours() ?? PLANNER_START_HOUR,
      minutes: businessHours?.start.minutes() ?? 0,
    });
  }

  getEndTimeOn(date: Moment): Moment {
    const businessHours = this.getBusinessHoursByDate(date);
    return date.clone().startOf('day').add({
      hours: businessHours?.end.hours() ?? PLANNER_END_HOUR,
      minutes: businessHours?.end.minutes() ?? 0,
    });
  }

  isAvailable(date: Moment, plannedEvents: Array<PlannerEvent>): boolean {
    if (plannedEvents.length !== 1) return true;
    if (plannedEvents[0].eventType !== PlannerEventType.ABSENCE) return true;
    const businessHours = this.getBusinessHoursByDate(date);
    return businessHours !== null && durationAsMinutes(plannedEvents[0].plannedDuration) < businessHours.laborMinutes;
  }
}
